import { BrandLogo } from '@/components/molecules/BrandLogo';
import { GlobeWrapper } from '@/components/molecules/GlobeWrapper';

export const AuthHero = () => {
  return (
    <div className="flex items-center w-full h-full overflow-hidden bg-white relative">
      <GlobeWrapper />
      <div className="flex flex-col justify-center w-[650px] p-8 absolute top-1/2 left-8 -translate-y-1/2">
        <BrandLogo />
        <div className="text-5xl">Delivering AI enabled Maritime Geospatial Intelligence</div>
        <div className="mt-4 max-w-[420px]">
          A powerful maritime monitoring platform that tracks vessel traffic, manages fleet operations, and monitors
          port congestion in real time. It allows users to create custom rules and triggers, set up geofences, and
          automate satellite imagery tasking to detect ships, even those operating as "dark vessels." Leveraging sensor
          fusion technology, it enhances detection capabilities by combining multiple data sources, such as satellite
          imagery and AIS signals. The app supports monitoring vessels within EEZ zones and automatically tracks and
          reports incidents like rule violations or unusual activity. Users can generate detailed reports and analyze
          vessel behaviors, port congestion, and other maritime events for effective decision-making and operational
          efficiency.
        </div>
      </div>
    </div>
  );
};
